"use client";

import type { UseOpenApiQueryOptions } from "../../../../../request/hooks/openApi/useOpenApiQuery";
import { useOpenApiQuery } from "../../../../../request/hooks/openApi/useOpenApiQuery";

const STRIPE_CONNECT_DASHBOARD_PATH =
  "/me/communities/{community_id}/stripe/dashboard" as const;

export type UseRequestCommunitiesStripeConnectDashboardProps = Omit<
  UseOpenApiQueryOptions<typeof STRIPE_CONNECT_DASHBOARD_PATH>,
  "urlBackendPath" | "params"
> & {
  id: number;
};

export const useRequestCommunitiesStripeConnectDashboard = ({
  id,
  ...props
}: UseRequestCommunitiesStripeConnectDashboardProps) => ({
  query: useOpenApiQuery({
    ...props,
    urlBackendPath: STRIPE_CONNECT_DASHBOARD_PATH,
    params: { path: { community_id: id } },
  }),
});
